export default function PHP_ucfirst() {
  return (
    <div>
      <h1>PHP_ucfirst</h1>
    </div>
  );
}
